/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPackageSelectItemsFromSortiment } from '../fn/package-sortiments/get-package-select-items-from-sortiment';
import { GetPackageSelectItemsFromSortiment$Params } from '../fn/package-sortiments/get-package-select-items-from-sortiment';
import { getPackageSortiment } from '../fn/package-sortiments/get-package-sortiment';
import { GetPackageSortiment$Params } from '../fn/package-sortiments/get-package-sortiment';
import { PackageSelectItemDto } from '../models/package-select-item-dto';
import { PagePackageSortimentResponse } from '../models/page-package-sortiment-response';


/**
 * Package sortiment resource endpoints. GET /sortiments/packages is accessible to all authenticated users. /select-items requires PRODUCT_ADMIN or EASYLOT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class PackageSortimentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPackageSortiment()` */
  static readonly GetPackageSortimentPath = '/sortiments/packages';

  /**
   * Gets packages sortiment.
   *
   * Finds and returns package sortiment of logged in merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackageSortiment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageSortiment$Response(params?: GetPackageSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<PagePackageSortimentResponse>> {
    const obs = getPackageSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets packages sortiment.
   *
   * Finds and returns package sortiment of logged in merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackageSortiment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageSortiment(params?: GetPackageSortiment$Params, context?: HttpContext): Observable<PagePackageSortimentResponse> {
    const resp = this.getPackageSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagePackageSortimentResponse>): PagePackageSortimentResponse => r.body)
    );
  }

  /** Path part for operation `getPackageSelectItemsFromSortiment()` */
  static readonly GetPackageSelectItemsFromSortimentPath = '/sortiments/packages/select-items';

  /**
   * Gets package dropdown select items from users sortiment.
   *
   * Finds and returns package select items from sortiment of logged in merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackageSelectItemsFromSortiment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageSelectItemsFromSortiment$Response(params: GetPackageSelectItemsFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PackageSelectItemDto>>> {
    const obs = getPackageSelectItemsFromSortiment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets package dropdown select items from users sortiment.
   *
   * Finds and returns package select items from sortiment of logged in merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackageSelectItemsFromSortiment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageSelectItemsFromSortiment(params: GetPackageSelectItemsFromSortiment$Params, context?: HttpContext): Observable<Array<PackageSelectItemDto>> {
    const resp = this.getPackageSelectItemsFromSortiment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PackageSelectItemDto>>): Array<PackageSelectItemDto> => r.body)
    );
  }

}
